import { useRef, useState } from "react";
import { ImagePlus, Trash2, Loader2 } from "lucide-react";

export default function PhotoControl({ image, onUpload, onRemove, testPrefix }) {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    await onUpload(file).finally(() => setBusy(false));
  };
  return (
    <div className="st-photo">
      <div className="st-photo-thumb">{image ? <img src={image} alt="" /> : <span>Fără imagine</span>}</div>
      <div className="st-photo-actions">
        <button type="button" className="st-btn st-btn--light" onClick={() => input.current.click()} disabled={busy} data-testid={`${testPrefix}-upload-btn`}>
          {busy ? <Loader2 size={16} className="animate-spin" /> : <ImagePlus size={16} />}
          {image ? "Schimbă poza" : "Încarcă poza"}
        </button>
        {image && (
          <button type="button" className="st-btn st-btn--ghost" onClick={onRemove} data-testid={`${testPrefix}-remove-btn`}>
            <Trash2 size={16} /> Elimină
          </button>
        )}
        <p className="st-hint">PNG cu fundal transparent sau alb arată cel mai premium.</p>
      </div>
      <input ref={input} type="file" accept="image/*" hidden onChange={pick} data-testid={`${testPrefix}-file-input`} />
    </div>
  );
}
